import React from 'react';

import { Helmet } from 'react-helmet'


const SiteInfo = () => {
    return (
        <Helmet>
            <html lang="en" />
            <title>Have It Made</title>
            <link rel="icon" type="image/x-icon" href="https://www.claytonhomes.com/images/favicon.ico?v=1" />
            <link rel="shortcut icon" type="image/png" href="https://www.claytonhomes.com/images/favicon.png?v=1" />
        </Helmet>
    );
};

export default SiteInfo;


// WEBPACK FOOTER //
// ./src/components/SiteInfo.js